import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { getMetadata } from "../api/metadata.api";

// // Define a type for the slice state


interface metadataResponse {
    name:string;
    value:string;
}

const metadataData = {
    name:'',
    value:'',

}

interface metadataState {
  metadata:metadataResponse;
  error: string;
}
// Define the initial state using that type
const initialState: metadataState = {
  metadata: metadataData,
  error: '',
};

export const fetchMetadata = createAsyncThunk(
  'getMetadata',
  async (storeCode: string, thunkApi) => {
    return getMetadata(storeCode).then(response => {
      //console.log(response);
      return response;
      
    })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const metadataSlice = createSlice({
    name: 'metadata',
    initialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchMetadata.pending, state => {
        return state;
      });
      builder.addCase(fetchMetadata.fulfilled, (state, {payload}) => {
        state.metadata = payload;
        //console.log(payload);
      });
      builder.addCase(fetchMetadata.rejected, (state, action) => {
        state.error = action.toString();

      });
    },
  });

// Other code such as selectors can use the imported `RootState` type
export const metadata = (state: RootState): metadataResponse =>
  state.metadataReducer.metadata;
export const error = (state: RootState): string => state.metadataReducer.error;


export default metadataSlice.reducer;
